import React from 'react';

const Icon = ({ type, name, className, ...rest }) => {
  const imagePath = `/assets/${name}.${type}`;

  if (type === 'svg' || type === 'png') {
    return (
      <span {...rest}>
        <img src={imagePath} alt={` ${name}`} className={className} />
      </span>
    );
  } else {
    return null;
  }
};

export default Icon;
